// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"230":"931700f3","241":"27e41655","362":"b3d5a275","423":"0a0a474a","453":"7c2afd4c","466":"f5fd9248","838":"0a9dab11","909":"6d4b3666","959":"9c5a9cd1"}[chunkId] + ".chunk.js";
};